<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "KioskInfo",
  data() {
    return {
      macAddress: "",
      kiosk_id: "",
      // loading: true,
    };
  },
  computed: {
    ...mapGetters("modal", ["getModalInfo", "getModalState"]),
    ...mapGetters("daemon", ["getLoading", "getKioskInfo"]),
    loading() {
      return this.getLoading;
    },
  },
  methods: {
    ...mapActions("daemon", ["fetchKioskInfo"]),
  },
  // addAlignModalCenter(id){
  //         setTimeout(()=>{
  //           let alignModalCenter = document.querySelector('id*=kioskInfo_');
  //           alignModalCenter.classList.add(id);
  //         },110);
  //       },
  watch: {
    getModalState(state) {
      state && this.$bvModal.hide("kioskInfo_" + this.kiosk_id);
    },
  },
  beforeMount() {
    this.macAddress = this.getModalInfo.mac_address;
    this.kiosk_id = this.getModalInfo.id;
    this.fetchKioskInfo(this.macAddress);
    // this.loading = false;
  },
};
</script>

<template>
  <div class="update-user-type-wrapper">
    <h4
      class="allareakiosk-header"
      :class="{ 'modal-header-no-info': Object.keys(getKioskInfo).length == 0 }"
    >
      Kiosk Info
    </h4>
    <svg
      class="close-modal-btn"
      @click="$bvModal.hide('kioskInfo_' + kiosk_id)"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 0C4.91333 0 0 4.91333 0 11C0 17.0867 4.91333 22 11 22C17.0867 22 22 17.0867 22 11C22 4.91333 17.0867 0 11 0ZM16.5978 14.7156C17.1111 15.2289 17.1111 16.06 16.5978 16.5733C16.3289 16.8422 16.0111 16.9644 15.6689 16.9644C15.3267 16.9644 14.9844 16.8422 14.74 16.5733L11.0733 12.9067L7.38222 16.5733C7.11333 16.8422 6.79556 16.9644 6.45333 16.9644C6.11111 16.9644 5.76889 16.8422 5.52444 16.5733C5.01111 16.06 5.01111 15.2289 5.52444 14.7156L9.21556 11.0244L5.52444 7.35778C5.01111 6.84444 5.01111 6.01333 5.52444 5.5C6.03778 4.98667 6.86889 4.98667 7.38222 5.5L11.0733 9.19111L14.7644 5.5C15.2778 4.98667 16.1089 4.98667 16.6222 5.5C17.1356 6.01333 17.1356 6.84444 16.6222 7.35778L12.9311 11.0489L16.5978 14.7156Z"
        fill="#F46A6A"
      />
    </svg>
    <b-spinner
      v-if="loading"
      variant="secondary"
      role="status"
      size="sm"
      class="unique-wizard-spinner"
    />
    <div v-else class="main-content">
      <b-form-group
        class="bold-txt align-items-center"
        label-cols-sm="3"
        label-cols-lg="12"
        v-for="(value, key) in getKioskInfo"
        :key="key"
        :label="key + ': '"
        :label-for="key"
      >
        <h5 :id="key" class="unique-txt text-primary mb-0">
          {{ value }}
        </h5>
      </b-form-group>
      <h5
        v-if="Object.keys(getKioskInfo).length == 0"
        class="text-primary mb-0 no-wrap modal-content-no-info"
      >
        No data found, please update your kiosk VisiPoint app.
      </h5>
    </div>
  </div>
</template>
<style lang="scss">
div[id*="kioskInfo_"] {
  div[class*="modal-content"] {
    width: 579px;
    div[class*="modal-body"] {
      padding: 0px !important;
      .unique-txt {
        font-weight: 700 !important;
        font-size: 16px !important;
        line-height: 17px !important;
        word-wrap: break-word !important;
        letter-spacing: 0.25px !important;
        width: 487px !important;
        color: rgba(0, 0, 0, 0.87) !important;
      }
      label {
        font-weight: 700 !important;
        font-weight: 700 !important;
        font-size: 12px !important;
        line-height: 17px !important;
        letter-spacing: 0.25px;
        opacity: 0.8 !important;
        color: #103f5e !important;
      }
      .form-group {
        font-weight: 700 !important;
      }
      .update-user-type-wrapper {
        padding-top: 41px;
        padding-inline-end: 0px;
        padding-bottom: 0px;
        padding-inline-start: 46px;
        h4.allareakiosk-header {
          font-weight: 700;
          font-size: 17px;
          line-height: 20px;
          color: #000000;
          margin-top: 0px;
          margin-inline-end: auto;
          margin-bottom: 15px;
          margin-inline-start: 0px;
          text-align: center;
        }
        .main-content {
          margin-inline-start: 0px;
          margin-inline-end: 46px;
          margin-bottom: 36px;
        }
      }
    }
  }
}
</style>

<style lang="scss" scoped>
::v-deep {
  .modal-header-no-info {
    color: #c7c7c7 !important;
    font-size: 14px !important;
    font-weight: 700 !important;
    line-height: 17px !important;
    letter-spacing: 0em !important;
    text-align: center !important;
    margin-inline-end: 20px !important;
  }
  .modal-content-no-info {
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: center;
    color: #495057;
  }
  .close-modal-btn {
    position: relative;
    bottom: 60px;
    inset-inline-start: 90%;
  }
  .unique-wizard-spinner {
    width: 30px;
    height: 30px;
    top: 20px;
    position: relative;
    inset-inline-start: 40%;
    margin-bottom: 40px;
  }
}
</style>
